import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';

interface FooterProps {
  className?: string;
}

export function Footer({ className = '' }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={cn(
        className,
        'bg-background-subtle py-6 px-4 md:py-10 md:px-14 text-body-base'
      )}
    >
      <div className="container mx-auto">
        <div className="space-y-4">
          <p className="">Copyright © {currentYear} Expected Healthcare</p>

          <p className="">
            Expected Healthcare does not provide medical advice, diagnosis, or
            treatment. Expected Healthcare does not recommend or endorse any
            specific physicians, imaging centers, professionals, products,
            procedures, or services. If you or someone you know is experiencing
            an emergency or crisis and needs immediate help, call 9-1-1 or go to
            the nearest emergency room.
          </p>

          <div className="flex flex-col gap-3 md:flex-row md:gap-6">
            <Link
              to="https://expectedhealthcare.com/terms-of-service/"
              target="_blank"
              className="underline"
            >
              Clinic Terms of Service
            </Link>
            <Link
              to="https://expectedhealthcare.com/privacy-policy/"
              target="_blank"
              className="underline"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
